import React from 'react';
import { Icon, Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { validationResultStatusIconProps } from '../../data/helper';

const DictionaryValidationStatusCell = ({ status }) => {
  const iconProps = validationResultStatusIconProps(status, true);
  return (
    <Table.Cell>
      <Icon color={iconProps.colour} name={iconProps.name} />
      {status && (<FormattedMessage id={`dataset.dictionary.report.validation.status.${status}`} />)}
    </Table.Cell>
  );
};

export default DictionaryValidationStatusCell;
